import { render, staticRenderFns } from "./OpenHours.vue?vue&type=template&id=512d0c4c&"
import script from "./OpenHours.vue?vue&type=script&lang=js&"
export * from "./OpenHours.vue?vue&type=script&lang=js&"
import style0 from "./OpenHours.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports